<template>
  <el-container class="home-wrapper">
    <div v-if="isMobile() && !isCollapse" class="mobile-mask" @click="foldCollapse"></div>

    <el-aside :width="asideWidth" class="main-aside">
      <el-menu
        :default-active="path"
        class="el-menu-vertical-demo"
        background-color="#00264a"
        text-color="#fff"
        active-text-color="#ffd04b"
        unique-opened
        :collapse="isCollapse"
        :collapse-transition="false"
        router>
        
        <div class="logo">
          <img src="../assets/whitelogo.png">
          <transition name="el-fade-in">
            <h1 v-show="!isCollapse">{{title}}</h1>
          </transition>
        </div>

        <template v-for="item in menuList">
          <el-submenu v-if="item.children && item.children.length > 0" :index="item.path" :key="item.id">
            <template slot="title">
              <i :class="iconObj[item.id]"></i>
              <span>{{ item.authName }}</span>
            </template>
            <el-menu-item 
              v-for="subItem in item.children" 
              :key="subItem.id" 
              :index="subItem.path" 
              @click="handleMenuClick(subItem.path)">
              <i :class="iconObj[subItem.id]"></i>
              <span slot="title">{{ subItem.authName }}</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :index="item.path" :key="item.id" @click="handleMenuClick(item.path)">
            <template v-if="item.authName === '接入文档'">
              <a href="http://docs.7ccccccc.com" target="_blank" class="external-link">
                <i :class="iconObj[item.id]"></i>
                <span slot="title">{{ item.authName }}</span>
              </a>
            </template>
            <div v-else>
              <i :class="iconObj[item.id]"></i>
              <span slot="title">{{ item.authName }}</span>
            </div>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container class="main-container">
      <el-header height="50px">
        <div class="header-left">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="foldCollapse"></i>
        </div>

        <div class="head-right">
          <el-button 
            class="share-btn" 
            size="small" 
            type="primary" plain
            v-clipboard:copy="shareCode" 
            v-clipboard:success="onCopyCode">
            <i class="iconfont icon-fenxiang"></i>
            <span class="hidden-xs">点击复制唯一标识码</span>
          </el-button>

          <el-dropdown trigger="click">
            <div class="user-info">
              <span class="user-email">{{ $store.state.account }}</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item @click.native="logout">
                <i class="iconfont icon-tuichu"></i>退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
        
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      //左侧菜单数据
      menuList:[],
      iconObj:{
        '125':'iconfont icon-xiaolian',
        '126':'iconfont icon-shujudaping',
        '127':'iconfont icon-xiangmuguanli',
        '128':'iconfont icon-qiamizhifu',
        '129':'iconfont icon-duoyonghu',
        '130':'iconfont icon-duoyonghu',
        '131':'iconfont icon-jilu-copy-copy',
        '132':'iconfont icon-yuancheng-o',
        '133':'iconfont icon-bianliang',
        '134':'iconfont icon-yuanchengshuju',
        '135':'iconfont icon-hanshu',
        '136':'iconfont icon-dai',
        '137':'iconfont icon-duoyonghu',
        '138':'iconfont icon-jilu-copy-copy',
        '139':'iconfont icon-jifenjilu',
        '140':'iconfont icon-bug',
        '141':'iconfont icon-zhaoshangdailifenlei',
        '142':'iconfont icon-jieru',

        '143':'iconfont icon-xiaolian',
        '144':'iconfont icon-xiangmuguanli',
        '145':'iconfont icon-qiamizhifu',
        '146':'iconfont icon-jilu-copy-copy',
        '147':'iconfont icon-jifenjilu',
        '148':'iconfont icon-zhaoshangdailifenlei',
        '149':'iconfont icon-chongzhi01',
      },
      isCollapse:false,
      path: this.$store.state.path,
      role: "",
      isShow: true,
      title: "",
      asideWidth:"",
      screenWidth: document.body.clientWidth,
      shareCode: window.sessionStorage.getItem('shareId'),
      dropdownWidth:""
    };
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler(newVal) {
        if (newVal <= 768) { 
          // 刚进入移动端范围
          this.isCollapse = true;
          this.asideWidth = '0px'; 
        } else {
          // PC 端
          if (newVal < 1000) {
            this.isCollapse = true;
            this.asideWidth = '64px';
          } else {
            this.isCollapse = false;
            this.asideWidth = '240px';
          }
        }
      }
    }
  },
  created(){
    //console.log(this.$store.state.shareMsg);
    // if(!this.$store.state.shareMsg){
    //   return this.$router.push("/developer/login");
    // }
    if (this.isMobile()) {
      console.log("移动端");
      this.isCollapse = true
      if (this.isCollapse) {
        this.asideWidth = '0px'
        this.title = ""
      }else {
        this.asideWidth = '240px'
        this.title = "七C云 ∙ 代理端"
      }
    } else {
      console.log("pc端");
      this.isCollapse = false
      if (this.isCollapse) {
        this.asideWidth = '64px'
        this.title = ""
      }else {
        this.asideWidth = '240px'
        this.title = "七C云 ∙ 代理端"
      }
    }
    this.$nextTick(()=>{
      this.dropdownWidth = this.$refs.emailwidh.offsetWidth
      if (document.body.clientWidth < 700){
        console.log(document.body.clientWidth);
        this.$refs.avatarRef.style.display = 'none'
      }
    })
    this.role = window.sessionStorage.getItem('role')
    // if(this.role == 'developer'){
    //   this.title = "七C云 ∙ 开发端"
    // }else if(this.role == 'agent'){
      
    // }
    this.getMenuList(this.role)
    this.path = window.sessionStorage.getItem('path')
  },
  mounted(){
    // this.$nextTick(()=>{
    //   if (document.body.clientWidth < 700){
    //     console.log(document.body.clientWidth);
    //     this.$refs.avatarRef.style.display = 'none'
    //     this.isCollapse = true
    //     if (this.isCollapse) {
    //       this.asideWidth = '64px'
    //     }else {
    //       this.asideWidth = '240px'
    //     }
    //   }
    // })
    this.$bus.$on('itemclick',(val)=>{
      //console.log('val=',val.username);
      window.sessionStorage.setItem('username', val.username)
      this.$router.push("/userlog");
      this.path = 'userlog'
    })

    const that = this
    window.onresize = ()=>{
      return(()=>{
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    handleMenuClick(path) {
      this.saveNavState(path);
      if(this.isMobile()) {
        this.isCollapse = true;
        this.asideWidth = '0px';
      }
    },
    logout() {
      window.sessionStorage.clear();
      // if(this.role == 'developer'){
      //   this.$router.push("developer/login");
      // }else if(this.role == 'agent'){
        this.$router.push("/login");
      // }
      this.$message.success("退出登录成功");
    },
    async getMenuList(role){
      let result
      // if(role == 'developer'){
      // //   console.log('developer');
      //   result = await this.$http.get('developer/menus')
      // }else if(role == 'agent'){
        //console.log('agent');
        result = await this.$http.get('agent/menus')
      // }
      console.log(result);
      if(result.data.meta.status !== 200){
        return this.$message.error(result.meta.msg)
      }
      this.menuList = result.data.data
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // localStorage.setItem('isiphone',flag)
      //console.log(flag)
      return flag;
    },
    foldCollapse(){
      if (this.isMobile()) {
        console.log("移动端");
        this.isCollapse = !this.isCollapse
        if (this.isCollapse) {
          this.asideWidth = '0px'
          this.title = ""
        }else {
          this.asideWidth = '240px'
          this.title = "七C云 ∙ 代理端"
        }
      } else {
        console.log("pc端");
        this.isCollapse = !this.isCollapse
        if (this.isCollapse) {
          this.asideWidth = '64px'
          this.title = ""
        }else {
          this.asideWidth = '240px'
          this.title = "七C云 ∙ 代理端"
        }
      }
    },
    onCopyCode(e){
      this.$message.success('唯一标识码已复制到剪贴板!')
    },
    saveNavState(index){
      //console.log(index);
      if(!index){
        this.path = window.sessionStorage.getItem('path')
      }else{
        window.sessionStorage.setItem('path', index)
        this.path = index
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-wrapper {
  height: 100vh;
  overflow: hidden;
}

.mobile-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}

.main-aside {
  background-color: #00264a;
  transition: none;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  overflow-x: hidden;

  .el-menu {
    border-right: none;
    height: 100%;
    overflow-y: auto; 
    overflow-x: hidden;
  }

  .logo {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    overflow: hidden;
    white-space: nowrap;
    
    img {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      flex-shrink: 0;
    }

    h1 {
      margin: 0 0 0 12px;
      padding: 0;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      
      line-height: 1.2;
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}

.main-container {
  overflow-y: auto;
  background-color: #f0f2f5;
  flex: 1;
  transition: none !important;
  margin-left: v-bind("isMobile() ? '0px' : asideWidth");
}

.el-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .header-left {
    i {
      font-size: 20px;
      cursor: pointer;
      color: #606266;
      &:hover { color: #409EFF; }
    }
  }
  .el-button {
    // margin: 0 10px 0 0;
    margin-right: 10px;
    margin-top:-2px;
    padding: 7px 8px;
    margin-top:0;
    i{
      font-size: 14px;
      margin: 0 10px 0 0;
    }
  }

  .head-right {
    display: flex;
    align-items: center;
    gap: 15px;

    .share-btn {
      margin: 0;
      display: flex;
      align-items: center;
      i { margin-right: 4px; font-size: 14px; }
    }

    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #606266;
      font-size: 14px;
      .user-email {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
}

.external-link {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
}



.el-main {
  background-color: #e9eef3;
  color: #333;
  // text-align: center;
  // line-height: 160px;
  padding: 0 0 20px 0;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.el-container {
  height: 100%;
}

.logo {
  height: 64px;
  padding: 0 20px;
  line-height: 64px;
  h1{
    font-size: 20px;
    color: #fff;
    display: inline;
    height: 50px;
    margin-left: 16px;
  }
}
a{
  color:#fff;
  text-decoration: none;
}
.el-popper /deep/ .popper__arrow {
  border-bottom-color: #1EBEF4 !important;
  left: 50% !important;
  visibility: hidden;
}
.header-new-drop li {
	width: 200px;
  color: red;
}

.user-dropdown-menu {
  padding: 5px 0 !important; 
  min-width: 100px !important; 
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  
  .el-dropdown-menu__item {
    line-height: 34px !important; 
    font-size: 13px !important;
    padding: 0 16px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    i {
      margin-right: 6px;
      font-size: 15px;
      color: #909399;
    }

    &:hover {
      background-color: #f5f7fa;
      color: #409eff;
      i {
        color: #409eff;
      }
    }
  }
}

.user-info {
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  
  .user-email {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  i {
    margin-left: 4px;
  }
}

@media screen and (max-width: 768px) {
  .hidden-xs {
    display: none !important;
  }
  
  .main-aside {
    position: fixed !important; /* 强制固定定位 */
    top: 0;
    left: 0;
    height: 100vh !important;
    z-index: 2000 !important; /* 移动端给最高层级 */
    visibility: v-bind("isCollapse ? 'hidden' : 'visible'");
    transform: v-bind("isCollapse ? 'translateX(-100%)' : 'translateX(0)'");
    transition: transform 0s !important;
  }

  .main-container {
    margin-left: 0 !important; /* 移动端内容必须靠左占满 */
    width: 100% !important;
  }

  /* 针对 Element 菜单在移动端的点击穿透修复 */
  .el-menu-item, .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    position: relative;
    z-index: 2001;
  }

  .el-header {
    padding: 0 10px;
    .head-right {
      gap: 8px;
    }
  }

  .user-email {
    max-width: 80px !important;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
}
</style>

